export default [
  {
    path: "/v3/property",
    name: "property",
		redirect: '/v3/property/overview',
		component: () => import('@/pages/v2/property/index'),
    children: [
			{
				path: 'overview',
				name: 'Overview', // 资产总览
				component: () => import("@/pages/v2/property/overview/index"),
			},
			{
				path: 'property-account',
				name: 'PropertyAccount', // 资金账户
				redirect: '/v3/property/property-account/account-list',
				component: () => import("@/pages/v2/property/propertyAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/propertyAccount/AccountList")
					},
					{
						path: 'recharge-record',
						name: 'RechargeRecord', // 充值记录
						component: () => import("@/pages/v2/property/propertyAccount/RechargeRecord")
					},
					{
						path: 'withdrawal-record',
						name: 'WithdrawalRecord', // 提币记录
						component: () => import("@/pages/v2/property/propertyAccount/WithdrawalRecord")
					},
					{
						path: 'transfer-record',
						name: 'TransferRecord', // 划转记录
						component: () => import("@/pages/v2/property/propertyAccount/TransferRecord")
					}
				]
			},

			{
				path: 'buying-account',
				name: 'BuyingAccount', // 买币账户
				redirect: '/v3/property/buying-account/account-list',
				component: () => import("@/pages/v2/property/buyingAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/buyingAccount/AccountList")
					},
					{
						path: 'transaction-record',
						name: 'TransactionRecord', // 买卖记录
						component: () => import("@/pages/v2/property/buyingAccount/TransactionRecord")
					},
					{
						path: 'transfer-record',
						name: 'TransferRecord', // 划转记录
						component: () => import("@/pages/v2/property/buyingAccount/TransferRecord")
					}
				]
			},
			{
				path: 'spot-account',
				name: 'SpotAccount', // 现货账户
				redirect: '/v3/property/spot-account/account-list',
				component: () => import("@/pages/v2/property/spotAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/spotAccount/AccountList")
					},
					{
						path: 'transfer-record',
						name: 'TransferRecord', // 划转记录
						component: () => import("@/pages/v2/property/spotAccount/TransferRecord")
					},
					{
						path: 'financial-records',
						name: 'FinancialRecords', // 财务记录
						component: () => import("@/pages/v2/property/spotAccount/FinancialRecords")
					}
				]
			},

			{
				path: 'contract-account',
				name: 'ContractAccount', // 合约账户
				redirect: '/v3/property/contract-account/account-list',
				component: () => import("@/pages/v2/property/contractAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/contractAccount/AccountList")
					},
					{
						path: 'transfer-record',
						name: 'TransferRecord', // 划转记录
						component: () => import("@/pages/v2/property/contractAccount/TransferRecord")
					},
					{
						path: 'financial-records',
						name: 'FinancialRecords', // 财务记录
						component: () => import("@/pages/v2/property/contractAccount/FinancialRecords")
					}
				]
			},
			// {
			// 	path: 'virtual-account',
			// 	name: 'VirtualAccount', // 合约账户
			// 	redirect: '/v3/property/virtual-account/account-list',
			// 	component: () => import("@/pages/v2/property/virtualAccount/index"),
			// 	children: [
			// 		{
			// 			path: 'account-list',
			// 			name: 'AccountList', // 资产列表
			// 			component: () => import("@/pages/v2/property/virtualAccount/AccountList")
			// 		},
			// 		{
			// 			path: 'financial-records',
			// 			name: 'FinancialRecords', // 财务记录
			// 			component: () => import("@/pages/v2/property/virtualAccount/FinancialRecords")
			// 		}
			// 	]
			// },
			{
				path: 'documentary-account',
				name: 'DocumentaryAccount', // 跟单账户
				redirect: '/v3/property/documentary-account/account-list',
				component: () => import("@/pages/v2/property/documentaryAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/documentaryAccount/AccountList")
					},
					{
						path: 'transfer-record',
						name: 'TransferRecord', // 划转记录
						component: () => import("@/pages/v2/property/documentaryAccount/TransferRecord")
					},
					{
						path: 'financial-records',
						name: 'FinancialRecords', // 财务记录
						component: () => import("@/pages/v2/property/documentaryAccount/FinancialRecords")
					}
				]
			},
		
			{
				path: 'earn',
				name: 'Financial', // 理财账户
				redirect: '/v3/property/earn/earn-list',
				component: () => import("@/pages/v2/property/earn/index"),
				children: [
					{
						path: 'earn-list',
						name: 'EarnList', // 资产
						component: () => import("@/pages/v2/property/earn/EarnList")
					},
					{
						path: 'earn-record',
						name: 'EarnRecord', // 划转记录
						component: () => import("@/pages/v2/property/earn/EarnRecord")
					},
					{
						path: 'swap-records',
						name: 'SwapRecords', // 财务记录
						component: () => import("@/pages/v2/property/earn/SwapRecords")
					}
				]
			},
			{
				path: 'gift-account',
				name: 'GiftAccount', // 赠金账户
				redirect: '/v3/property/gift-account/account-list',
				component: () => import("@/pages/v2/property/giftAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/giftAccount/AccountList")
					},
					{
						path: 'transfer-record',
						name: 'TransferRecord', // 划转记录
						component: () => import("@/pages/v2/property/giftAccount/TransferRecord")
					},
					{
						path: 'financial-records',
						name: 'FinancialRecords', // 财务记录
						component: () => import("@/pages/v2/property/giftAccount/FinancialRecords")
					}
				]
			},
			{
				path: 'biking-account',
				name: 'BikingAccount', // 币王账户
				redirect: '/v3/property/biking-account/account-list',
				component: () => import("@/pages/v2/property/bikingAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/bikingAccount/AccountList")
					},
					{
						path: 'financial-records',
						name: 'FinancialRecords', // 财务记录
						component: () => import("@/pages/v2/property/bikingAccount/FinancialRecords")
					}
				]
			},
			{
				path: 'game-account',
				name: 'GameAccount', // 游戏账户
				redirect: '/v3/property/game-account/account-list',
				component: () => import("@/pages/v2/property/gameAccount/index"),
				children: [
					{
						path: 'account-list',
						name: 'AccountList', // 资产列表
						component: () => import("@/pages/v2/property/gameAccount/AccountList")
					},
					// {
					// 	path: 'transfer-record',
					// 	name: 'TransferRecord', // 划转记录
					// 	component: () => import("@/pages/v2/property/gameAccount/TransferRecord")
					// },
					{
						path: 'game-records',
						name: 'GameRecords', // 游戏记录
						component: () => import("@/pages/v2/property/gameAccount/GameRecords")
					}
				]
			},
			// {
			// 	path: '/v3/property-account/recharge',
			// 	name: 'Recharge', // 充值
			// 	component: () => import("@/pages/v2/property/Recharge"),
			// },
			// {
			// 	path: '/v3/property-account/withdrawal',
			// 	name: 'Withdrawal', // 提现
			// 	component: () => import("@/pages/v2/property/Withdrawal"),
			// },
			{
				path: '/v3/property-account/recharge/address',
				name: 'RechargeAddress', // 充值
				component: () => import("@/pages/v2/property/components/add-moreaddress.vue"),
			},
			{
				path: '/v3/property-account/withdrawal/addressManage',
				name: 'addressManage', // 提现地址管理
				component: () => import("@/pages/v2/property/withdrawal-address-manage"),
			}
		],
    meta: {
      i18n: {
        zh_CN: () => require("@/i18n/lang/property/zh.js"),
        en_US: () => require("@/i18n/lang/property/en.js"),
        // ko_KR: () => require("@/i18n/lang/property/kr.js"),
        zh_TW: () => require("@/i18n/lang/property/tw.js"),
		id_ID: () => require("@/i18n/lang/property/ba.js"),
		tr_TR: () => require("@/i18n/lang/property/tr.js"),
		vi_VN: () => require("@/i18n/lang/property/vi.js"),
		ru_Ru: () => require("@/i18n/lang/property/ru.js"),
		fr_FR: () => require("@/i18n/lang/property/fr.js"),
      },
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/v2/property/index.js